import styles from '../../../../styles/incidents.module.css';
import { useFieldArray } from 'react-hook-form';
import { useState } from 'react';
import IncidentNotificationsAdd from './incidentnotificationsadd';
import IncidentNotificationsList from './incidentnotificationslist';

const IncidentNotifications = ({control,notificationtypes = []}) => {
    const [addMode,setAddmode] = useState(false);
    const [editIndex,setEditIndex] = useState(null);

    const {fields,append,remove,update} = useFieldArray({
        control,
        name: 'notifications',
        keyName: 'rhfid' //RHF needs an id to automatically track. By default this is id but since we already use id we must change
    });

    return(
        <div className={styles.notificationsContainer}>
            {
                addMode
                ?
                    <IncidentNotificationsAdd toggleViewNotifications={() => {setAddmode(false); setEditIndex(null)}} item={editIndex !== null ? fields[editIndex] : null} notificationTypes={notificationtypes} onSubmitFn={(data) => {
                        const entryWithId = {
                            ...data,
                            id: data.id !== null ? data.id : crypto.randomUUID(), // preserve existing id if editing
                        };
                        if (editIndex !== null) {
                        update(editIndex, entryWithId);
                        } else {
                        append(entryWithId);
                        }
                        setAddmode(false);
                        setEditIndex(null);
                        }}
                    />
                :
                    <IncidentNotificationsList fields={fields} toggleAdd={() => {setAddmode(true); setEditIndex(null)}} onEdit={(index) => {setEditIndex(index); setAddmode(true)}} notificationTypes={notificationtypes} remove={remove}/>
            }
        </div>
    )
}

export default IncidentNotifications;